import { useState } from 'react';
import {addAdditive} from "../../services/Administrative/additiveService";
import {addNewComponent} from "../../services/Administrative/componentService";

export const useAddComponent = () => {
    const [saving, setSaving] = useState(false);

    const addComponent = async (newAdditiveDTO: any) => {
        setSaving(true);
        try {
            const response:any = await addNewComponent(newAdditiveDTO);
            return response.data.component;
        } catch (error: any) {
            throw error.response.data.message;
        } finally {
            setTimeout(() => setSaving(false), 600);
        }
    };

    return { addComponent, saving };
};